import { getAuthentication } from "../../lib/auth";
import { BETTING_WEBSITE_RELATIVES_URL } from "../../lib/env";
import { escapeGqlString, gqlRequest } from "../../lib/functions";
import { BETTINGWEBSITEQANDAGQLSCHEMA } from "../../lib/gql/BettingWebsite.QAndA";
import { IBettingWebsiteQAndA } from "../../types/BettingWebsite.QAndA";
import { IMultiLanguageInputArgs } from "../../types/MultiLanguageInput";

export async function getQuestions(
  limit: number,
  offset: number,
  query: string
): Promise<IBettingWebsiteQAndA[]> {
  let filters = "";
  if (query && query.trim() !== "") {
    filters = `,query:"${query}"`;
  }
  const gqlString = `query{
        GetBettingWebsiteQuestionAndAnswer(limit:${limit},offset:${offset}${filters}){
            ${BETTINGWEBSITEQANDAGQLSCHEMA}
        }
    }`;

  try {
    const response = await gqlRequest<{
      GetBettingWebsiteQuestionAndAnswer: IBettingWebsiteQAndA[];
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.GetBettingWebsiteQuestionAndAnswer || [];
  } catch (err) {
    throw err;
  }
}

export async function getQuestionByID(
  id: string
): Promise<IBettingWebsiteQAndA | null> {
  const gqlString = `query{
        GetBettingWebsiteQAndAByID(id:"${id}"){
            ${BETTINGWEBSITEQANDAGQLSCHEMA}
        }
    }`;
  try {
    const response = await gqlRequest<{
      GetBettingWebsiteQAndAByID: IBettingWebsiteQAndA;
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.GetBettingWebsiteQAndAByID || null;
  } catch (err) {
    throw err;
  }
}

export async function addNewQuestion(
  question: IMultiLanguageInputArgs,
  Type: "S" | "B"
): Promise<IBettingWebsiteQAndA | null> {
  const gqlString = `mutation{
        AddNewBettingWebsiteQuestionAndAnswer(question:{
            en:"${escapeGqlString(question.en)}",
            ar:"${escapeGqlString(question.ar)}",
            fr:"${escapeGqlString(question.fr)}"    
        },Type:"${Type}"){
            ${BETTINGWEBSITEQANDAGQLSCHEMA}
        }
    }`;

  try {
    const response = await gqlRequest<{
      AddNewBettingWebsiteQuestionAndAnswer: IBettingWebsiteQAndA;
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.AddNewBettingWebsiteQuestionAndAnswer || null;
  } catch (err) {
    throw err;
  }
}

export async function editQuestion(
  id: string,
  question: IMultiLanguageInputArgs,
  Type: "S" | "B"
): Promise<IBettingWebsiteQAndA | null> {
  const gqlString = `mutation{
          EditBettingWebsiteQuestionAndAnswer(id:"${id}",question:{
              en:"${escapeGqlString(question.en)}",
              ar:"${escapeGqlString(question.ar)}",
              fr:"${escapeGqlString(question.fr)}"    
          },Type:"${Type}"){
              ${BETTINGWEBSITEQANDAGQLSCHEMA}
          }
      }`;

  try {
    const response = await gqlRequest<{
      EditBettingWebsiteQuestionAndAnswer: IBettingWebsiteQAndA;
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.EditBettingWebsiteQuestionAndAnswer || null;
  } catch (err) {
    throw err;
  }
}

export async function deleteQuestion(id: string): Promise<boolean | undefined> {
  const gqlString = `mutation{
        DeleteBettingWebsiteQuestionAndAnswer(id:"${id}")
    }`;
  try {
    const response = await gqlRequest<{
      DeleteBettingWebsiteQuestionAndAnswer: boolean;
    }>({
      query: gqlString,
      endpoint: BETTING_WEBSITE_RELATIVES_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });
    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    return response?.data?.DeleteBettingWebsiteQuestionAndAnswer;
  } catch (err) {
    throw err;
  }
}
